/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Venue_PrimaryInputs */

const th_venue_primary = /** @type {(inputs: Venue_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สนามหลัก`)
};

const en_venue_primary = /** @type {(inputs: Venue_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primary`)
};

const ja_venue_primary = /** @type {(inputs: Venue_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メイン会場`)
};

const zh_venue_primary = /** @type {(inputs: Venue_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主场馆`)
};

const es_venue_primary = /** @type {(inputs: Venue_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principal`)
};

const pt_venue_primary = /** @type {(inputs: Venue_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principal`)
};

const id_venue_primary = /** @type {(inputs: Venue_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempat utama`)
};

const fr_venue_primary = /** @type {(inputs: Venue_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principale`)
};

const tl_venue_primary = /** @type {(inputs: Venue_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pangunahing venue`)
};

const vi_venue_primary = /** @type {(inputs: Venue_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Địa điểm chính`)
};

const ko_venue_primary = /** @type {(inputs: Venue_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`주 경기장`)
};

const de_venue_primary = /** @type {(inputs: Venue_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haupthalle`)
};

const ru_venue_primary = /** @type {(inputs: Venue_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Основная площадка`)
};

const tr_venue_primary = /** @type {(inputs: Venue_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ana salon`)
};

const it_venue_primary = /** @type {(inputs: Venue_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impianto principale`)
};

const pl_venue_primary = /** @type {(inputs: Venue_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hala główna`)
};

const uk_venue_primary = /** @type {(inputs: Venue_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Головний майданчик`)
};

const hi_venue_primary = /** @type {(inputs: Venue_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मुख्य स्थल`)
};

const ar_venue_primary = /** @type {(inputs: Venue_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الصالة الرئيسية`)
};

const ms_venue_primary = /** @type {(inputs: Venue_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempat utama`)
};

const bn_venue_primary = /** @type {(inputs: Venue_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রধান মাঠ`)
};

const zh_tw2_venue_primary = /** @type {(inputs: Venue_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主要場館`)
};

const zh_hk2_venue_primary = /** @type {(inputs: Venue_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主要場館`)
};

const ur_venue_primary = /** @type {(inputs: Venue_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بنیادی مقام`)
};

const fa_venue_primary = /** @type {(inputs: Venue_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سالن اصلی`)
};

const sw_venue_primary = /** @type {(inputs: Venue_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukumbi mkuu`)
};

const nl_venue_primary = /** @type {(inputs: Venue_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoofdzaal`)
};

/**
* | output |
* | --- |
* | "Primary" |
*
* @param {Venue_PrimaryInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const venue_primary = /** @type {((inputs?: Venue_PrimaryInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Venue_PrimaryInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_venue_primary(inputs)
	if (locale === "ja") return ja_venue_primary(inputs)
	if (locale === "zh") return zh_venue_primary(inputs)
	if (locale === "es") return es_venue_primary(inputs)
	if (locale === "pt") return pt_venue_primary(inputs)
	if (locale === "id") return id_venue_primary(inputs)
	if (locale === "fr") return fr_venue_primary(inputs)
	if (locale === "tl") return tl_venue_primary(inputs)
	if (locale === "vi") return vi_venue_primary(inputs)
	if (locale === "ko") return ko_venue_primary(inputs)
	if (locale === "de") return de_venue_primary(inputs)
	if (locale === "ru") return ru_venue_primary(inputs)
	if (locale === "tr") return tr_venue_primary(inputs)
	if (locale === "it") return it_venue_primary(inputs)
	if (locale === "pl") return pl_venue_primary(inputs)
	if (locale === "uk") return uk_venue_primary(inputs)
	if (locale === "hi") return hi_venue_primary(inputs)
	if (locale === "ar") return ar_venue_primary(inputs)
	if (locale === "ms") return ms_venue_primary(inputs)
	if (locale === "bn") return bn_venue_primary(inputs)
	if (locale === "zh-TW") return zh_tw2_venue_primary(inputs)
	if (locale === "zh-HK") return zh_hk2_venue_primary(inputs)
	if (locale === "ur") return ur_venue_primary(inputs)
	if (locale === "fa") return fa_venue_primary(inputs)
	if (locale === "sw") return sw_venue_primary(inputs)
	if (locale === "nl") return nl_venue_primary(inputs)
	return en_venue_primary(inputs)
});